import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'wouter';
import { cx } from '@/lib/cx';
import type { ButtonVariant } from './Button';
import styles from './Button.module.css';

/** Link com a aparência do Button (navegação interna via wouter, sem recarregar). */
export function ButtonLink({
  href,
  variant,
  size = 'md',
  icon: Icon,
  children,
  className,
  'data-testid': testId,
}: {
  href: string;
  variant: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <Link
      href={href}
      className={cx(styles.button, className)}
      data-variant={variant}
      data-size={size}
      data-testid={testId}
    >
      {Icon && (
        <Icon size={size === 'lg' ? 18 : 16} strokeWidth={1.75} aria-hidden="true" className={styles.icon} />
      )}
      <span className={styles.label}>{children}</span>
    </Link>
  );
}
